import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const BoardPage = lazy(() => import('@/pages/community/board/page'));
const FanCommentPage = lazy(() => import('@/pages/community/fan/FanCommentPage'))
const CommentPage = lazy(() => import('@/pages/community/content/page'))
const ForbiddenPage = lazy(() => import('@/pages/community/forbiddenWords/ForbiddenPage'))

/**
 * 커뮤니티 관리 라우트
 * - 게시판
 * - 팬보드
 * - 콘텐츠 댓글
 * - 금칙어
 */

export const communityRoutes: RouteWithMeta = {
  path: 'community',
  meta: {
    label: '커뮤니티',
    showInMenu: true,
    icon: ''
  },
  children: [
    // ===== 게시판 =====
    {
      path: 'board',
      element: withSuspense(<BoardPage/>),
      meta: {
        label: '게시판',
        showInMenu: true,
      }
    },
    // ===== 팬보드 =====
    {
      path: 'fans',
      element: withSuspense(<FanCommentPage/>),
      meta: {
        label: '팬보드',
        showInMenu: true,
      }
    },

    // ===== 콘텐츠 댓글 =====
    {
      path: 'content',
      element: withSuspense(<CommentPage/>),
      meta: {
        label: '콘텐츠 댓글',
        showInMenu: true,
      }
    },

    // ===== 금칙어 =====
    {
      path: 'forbidden',
      element: withSuspense(<ForbiddenPage/>),
      meta: {
        label: '금칙어',
        showInMenu: true,
      }
    },

  ]
}